import { type ReactElement } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { buildProjectScopedPath } from '@/features/projects/utils/projectScopedRoutes';

export const ProjectScopedRedirect = ({ path }: { path: string }): ReactElement => {
  const { workspaceSlug, projectSlug } = useParams<{
    workspaceSlug: string;
    projectSlug: string;
  }>();

  if (!workspaceSlug || !projectSlug) {
    return <Navigate to="/execution-runs" replace />;
  }

  return <Navigate to={buildProjectScopedPath({ workspaceSlug, projectSlug, path })} replace />;
};
